import axiosInstance from './axiosInstance';

  export const getUserId = async () => {
    return await axiosInstance.get('/api/utils/health/user');
  };

  export const getPaises = async () => {
    return await axiosInstance.get('/api/utils/paises/');
  };

  export const getNotifications = async () => {
    return await axiosInstance.get('/api/notificaciones/');
  };
  
  export const markNotificationAsRead = async (notificationId) => {
    return await axiosInstance.patch(`/api/notificaciones/${notificationId}/`, { visto: true });
  };

  export const sendNotification = async (payload) => {
    return await axiosInstance.post(`/api/notificaciones/`, payload);
  };
